import { useState } from "react";

import { ContainerButton } from "@component/buttons/buttons";
import {
  getKikoffCreditAccountMentalModelName,
  useCreditServiceGenericMentalModelName,
} from "@src/constants";
import { l10nResources } from "@util/l10n";

import PageAlign from "../../page_align";

import styles from "./styles.module.scss";

const rows = [
  "Administrative fees",
  "Annual fees",
  "Late fees",
  "Maximum APR",
  "Annual finance charge",
];

const cols = [
  getKikoffCreditAccountMentalModelName(),
  "Competitor Secured Installment Credit Builders",
  "Competitor Secured Credit Cards",
];

const data = [
  ["$0", "$8.95-$25", "$9"],
  ["$0", "$0", "$25-$35"],
  ["$0", "5% of monthly payment", "$15-$38"],
  ["0%", "13.50%-15.92%", "17%-23.74% "],
  ["$0", "$89-$128", "$0"],
];

const l10n = l10nResources({
  en: `disclaimer-pricing = Kikoff services may result in bank fees when customer accounts are debited. Banks may charge nonsufficient fund fees, overdraft fees, or other fees. Credit cards may also incur interest charges. Kikoff is not responsible for any bank fees. Competitor secured credit cards refers to secured credit cards other than Kikoff.
`,
  es: `disclaimer-pricing = Los servicios de Kikoff pueden generar cargos bancarios cuando se debitan las cuentas de los clientes. Los bancos pueden cobrar tarifas por fondos insuficientes, tarifas por sobregiro u otras tarifas. Las tarjetas de crédito también pueden generar cargos por intereses. Kikoff no es responsable de ninguna comisión bancaria. Las tarjetas de crédito aseguradas de la competencia se refieren a tarjetas de crédito aseguradas distintas de Kikoff.
`,
});

function Desktop() {
  return (
    <table className={styles.desktop}>
      <thead>
        <tr>
          <th> </th>
          {cols.map((col, i) => (
            <th key={i}>{col}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, r) => (
          <tr key={r}>
            <td>{rows[r]}</td>
            {row.map((cell, c) => (
              <td key={c}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function Mobile() {
  const [index, setIndex] = useState(0);

  return (
    <div className={styles.mobile}>
      <header>
        <ContainerButton
          className={styles.icon}
          onClick={() => setIndex((index - 1 + rows.length) % rows.length)}
        >
          
        </ContainerButton>
        <div className={styles.titles}>
          {rows.map((row, i) => (
            <div
              className={styles.title}
              style={{ left: `${i - index}00%` }}
              key={i}
            >
              {row}
            </div>
          ))}
        </div>
        <ContainerButton
          className={styles.icon}
          onClick={() => setIndex((index + 1) % rows.length)}
        >
          
        </ContainerButton>
      </header>
      <div className={styles["tables-container"]}>
        <div
          className={styles.tables}
          style={{ width: `${rows.length}00%`, marginLeft: `-${index}00%` }}
        >
          {data.map((row, r) => (
            <table key={r} style={{ width: `${100 / rows.length}%` }}>
              <tbody>
                {row.map((entry, e) => (
                  <tr className={styles.entry} key={e}>
                    <th>
                      <div>{cols[e]}</div>
                    </th>
                    <td>
                      <div>{entry}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ))}
        </div>
      </div>
    </div>
  );
}

function PricingSection() {
  const monthlyPayment = 5;
  const creditServiceGenericMentalModelName = useCreditServiceGenericMentalModelName();

  return (
    <section className={styles["pricing-container"]} id="pricing">
      <PageAlign innerClassName={styles["pricing"]}>
        <h1 className="text:heading-3">
          How much does Kikoff cost? A flat ${monthlyPayment}/month for{" "}
          {creditServiceGenericMentalModelName}.
        </h1>
        <Desktop />
        <Mobile />
        <PricingLegalFootnote />
      </PageAlign>
    </section>
  );
}

function PricingLegalFootnote() {
  return (
    <p className="text:legal-primary">{l10n.getString("disclaimer-pricing")}</p>
  );
}

export default PricingSection;
